<template>
  <div class="mb10 price serif py10 center-xs start-md">
    <div v-if="canShowSpecialPrice && !product.stock.is_qty_decimal"
         class="h3 cl-secondary"
    >
      <span class="h4 cl-mine-shaft weight-700 price-special">
        {{ (parseFloat(product.special_price) + mandatoryOptionsPrice + options) * qty | price }}
      </span>
      <span v-if="!finalPrice" class="price-original h4 price-before-discount">
        {{ (parseFloat(product.price) + mandatoryOptionsPrice + options) * qty | price }}
      </span>
    </div>
    <div v-if="canShowSpecialPrice && product.stock.is_qty_decimal"
         class="h3 cl-secondary"
    >
      <span v-if="!finalPrice" class="price-original price-before-discount ">
        {{ parseFloat(product.price) + mandatoryOptionsPrice + options | price }}
      </span>
      <span class="cl-secondary h4">/</span>
      <span class="h4 cl-mine-shaft weight-700 price-special">
        {{ parseFloat(product.special_price) + mandatoryOptionsPrice + options | price }}
        <span class="decimal-qty-title weight-300">{{ $t('for 1 kg') }}</span>
      </span>
    </div>
    <div v-if="!canShowSpecialPrice && product.price && !product.stock.is_qty_decimal"
         class="h4 cl-mine-shaft weight-700"
    >
      {{ !!qty ? (parseFloat(product.price) + mandatoryOptionsPrice + options) * qty : parseFloat(product.price) + mandatoryOptionsPrice + options | price }}
    </div>
    <div v-if="!canShowSpecialPrice && product.price && product.stock.is_qty_decimal"
         class="h4 cl-mine-shaft weight-700"
    >
      {{ parseFloat(product.price) + mandatoryOptionsPrice + options | price }}
      <span v-if="!finalPrice" class="decimal-qty-title weight-300">{{ $t('for 1 kg') }}</span>
    </div>
  </div>
</template>
<script>

import { canShowSpecialPriceForProduct } from '@vue-storefront/core/modules/catalog/helpers/tax'
import { getMandatoryCustomOptionsPrice } from 'theme/helpers/customOptions'

export default {
  name: 'ProductPrice',
  props: {
    product: {
      type: Object,
      required: true
    },
    qty: {
      type: Number,
      required: true
    },
    finalPrice: {
      type: Boolean,
      default: false,
      required: false
    },
    options: {
      type: Number,
      default: 0,
      required: false
    }
  },
  computed: {
    canShowSpecialPrice () {
      return canShowSpecialPriceForProduct(this.product)
    },
    mandatoryOptionsPrice () {
      return getMandatoryCustomOptionsPrice(this.product)
    }
  }
}
</script>

<style lang="scss" scoped>
  .price-before-discount {
    text-decoration: line-through;
  }
  .price {
    >div {
      display: flex;
      row-gap: 4px;
      column-gap: 16px;
    }
  }
</style>

<style lang="scss">
  .prices {
    .price {
      text-align: start;
      >div {
        flex-direction: column-reverse;
        color: #333333;
      }
      .price-special {
        color: #11bb2e!important;
      }
    }
    .cl-mine-shaft, .price-original {
      font-size: 14px;
      text-align: start;
      font-family: 'TTNorms Bold', sans-serif;
    }
  }
</style>
